import type { SimplePagination as SimplePaginationProps } from "@motain/xpa-proto-files-web/lib/types/simple_pagination";
import styles from "./SimplePagination.module.scss";
import classNames from "classnames";
import { SimplePaginationLink } from "./simple-pagination-link/SimplePaginationLink";
import { isNonNullable } from "@/types/isNonNullable";

export const SimplePagination: React.FC<SimplePaginationProps> = (props) => {
  const { titleA11y, pageMessage, prevLink, nextLink } = props;
  return (
    <nav aria-label={titleA11y} className={styles.container}>
      <div className={styles.content}>
        <p className={classNames("title-8-medium", styles.message)}>
          {pageMessage}
        </p>
        {isNonNullable(prevLink) && isNonNullable(nextLink) && (
          <ul className={styles.links}>
            <li>
              <SimplePaginationLink
                link={prevLink.link}
                kind="prev"
                isDisabled={prevLink.isDisabled}
              />
            </li>
            <li>
              <SimplePaginationLink
                link={nextLink.link}
                kind="next"
                isDisabled={nextLink.isDisabled}
              />
            </li>
          </ul>
        )}
      </div>
    </nav>
  );
};
